$("#search-field").ghostHunter({
		results: "#results",
		displaySearchInfo: true,
		zeroResultsInfo: true,
		info_template     : "<h3 class='num-results'>Articles found: {{amount}}</h3>",
		result_template     : "<a id='gh-{{ref}}' class='gh-search-item' href='{{link}}'><h2 class='search-item-title'>{{title}}</h2><span class='date'>{{pubDate}}</span><p class='description'>{{description}}</p></a>",
	});
